import Button from 'common/components/button/Button';
import Label from 'common/components/label/Label';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import styles from './VehicleActivationModal.module.scss';


type Props = {
    isVisible: boolean;
    isToActivate: boolean;
    onActivate?: () => void;
    onActivateAndFinishReplace?: () => void;

    onDeactivate?: () => void;
    onDeactivateAndReplace?: () => void;
    onCancel: () => void;
};

const VehicleActivationModal: React.FC<Props> = ({ isVisible, isToActivate, onActivate, onActivateAndFinishReplace, onDeactivate, onDeactivateAndReplace, onCancel }: Props) => {
    const { t } = useTranslation();

    const customStyles = {
        content: {
            top: '15%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translateX(-50%)',
            width: '90%',
            maxWidth: '650px',
            padding: '20px',
            backgroundClip: 'padding-box',
            backgroundColor: '#FFFFFF',
            border: '1px solid transparent',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            outline: '0 none',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
        }
    };


    return (
        <Modal isOpen={isVisible} style={customStyles}>
            <div className={styles.modalContent}>
                <div className={styles.titleContainer}>
                    <Label className={styles.textTitle}>{t('common.question')}</Label>
                </div>
                <div className={styles.messageContainer}>
                    <label className={styles.textMessage} dangerouslySetInnerHTML={{ __html: (isToActivate ? t('vehicle.activate_message') : t('vehicle.deactivate_message')) }}></label>
                </div>
                <div className={styles.buttonsContainer}>
                    <div>
                        <Button text={t('common.cancel')} preset={'secondary'} size={'small'} onClick={onCancel}  style={{ marginLeft: 0 }}/>
                    </div>
                    <div>
                        {isToActivate ?
                            <>
                                <Button text={t('common.activate')} preset={'secondary'} size={'small'} onClick={onActivate} />
                                <Button text={t('vehicle.activate_and_finish_replace')} size={'small'} onClick={onActivateAndFinishReplace} />
                            </>
                            :
                            <>
                                <Button text={t('common.deactivate')} preset={'danger'} size={'small'} onClick={onDeactivate} />
                                <Button text={t('vehicle.deactivate_and_replace')} preset={'secondary-success'} size={'small'} onClick={onDeactivateAndReplace} />
                            </>}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default VehicleActivationModal;
